(function () {
  'use strict';

  function initializePromoBar(bar) {
    let slides = Array.from(bar.querySelectorAll('.js-promo-slide'));
    let activeIndex = 0;
    let rotationTimer;
    let countdownTimer;
    const rotationSpeed = Number.parseInt(bar.dataset.rotationSpeed, 10) || 5000;

    function showSlide(index) {
      if (slides.length === 0) return;
      activeIndex = ((index % slides.length) + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        const isActive = slideIndex === activeIndex;
        slide.hidden = !isActive;
        slide.setAttribute('aria-hidden', String(!isActive));
      });
    }

    function stopRotation() {
      window.clearInterval(rotationTimer);
    }

    function startRotation() {
      stopRotation();
      if (slides.length > 1) {
        rotationTimer = window.setInterval(function () {
          showSlide(activeIndex + 1);
        }, rotationSpeed);
      }
    }

    function removeExpiredCampaign(campaign) {
      const wasActive = !campaign.hidden;
      campaign.remove();
      slides = Array.from(bar.querySelectorAll('.js-promo-slide'));
      if (wasActive || activeIndex >= slides.length) activeIndex = 0;
      showSlide(activeIndex);
      startRotation();
      window.clearInterval(countdownTimer);
    }

    function initializeCampaign() {
      const campaign = bar.querySelector('.js-campaign-slide');
      if (!campaign) return;

      const endTime = new Date(campaign.dataset.campaignEnd).getTime();
      const countdown = campaign.querySelector('.js-countdown');
      if (!Number.isFinite(endTime)) {
        removeExpiredCampaign(campaign);
        return;
      }

      function updateCountdown() {
        const remaining = endTime - Date.now();
        if (remaining <= 0) {
          removeExpiredCampaign(campaign);
          return;
        }
        if (!countdown) return;

        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        countdown.querySelector('.js-days').textContent = String(days);
        countdown.querySelector('.js-hours').textContent = String(hours).padStart(2, '0');
        countdown.querySelector('.js-minutes').textContent = String(minutes).padStart(2, '0');
      }

      updateCountdown();
      countdownTimer = window.setInterval(updateCountdown, 60000);
    }

    bar.addEventListener('mouseenter', stopRotation);
    bar.addEventListener('mouseleave', startRotation);
    bar.addEventListener('focusin', stopRotation);
    bar.addEventListener('focusout', startRotation);
    bar.addEventListener('click', function (event) {
      const button = event.target.closest('.js-copy-code');
      if (!button) return;

      const code = button.dataset.code;
      if (!code || !navigator.clipboard?.writeText) return;
      navigator.clipboard.writeText(code).then(function () {
        const originalLabel = button.textContent;
        button.textContent = button.dataset.copiedLabel;
        window.setTimeout(function () {
          button.textContent = originalLabel;
        }, 2000);
      });
    });

    showSlide(0);
    initializeCampaign();
    startRotation();
  }

  function initialize() {
    document.querySelectorAll('.js-promo-bar').forEach(initializePromoBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
